export default __webpack_public_path__ + "static/media/CHECK_BLANCO.4ba061bb.png";